import HTTP from '@/plugins/http';

const apiUrl = {
  page: '/walletAmount/list/page',
  list: '/walletRecord/walletAmount/count',
  export: '/walletAmount/list/export',
  export1: '/walletRecord/walletAmount/export'
};

function getPage({ data, params }) {
  return HTTP({ url: apiUrl.page, method: 'post', data: { ...data, ...params } });
}
function getList(data) {
  return HTTP({ url: apiUrl.list, method: 'post', data });
}
function doExport(params) {
  return HTTP.loading({
    url: apiUrl.export,
    method: 'post',
    data: params,
    responseType: 'blob'
  });
}
function doExport1(params) {
  return HTTP.loading({
    url: apiUrl.export1,
    method: 'post',
    data: params,
    responseType: 'blob'
  });
}

export default { getPage, doExport, doExport1, getList };



// WEBPACK FOOTER //
// ./src/api/walletAmount.js